import {
  faBorderAll, faIdCard, faList, faToggleOn,
} from '@fortawesome/pro-light-svg-icons'

import { ProviderPriceListModel } from '@models/providerPriceList'

import { generateUrls } from '@hooks/useProviderPriceList'

const generateTabBarItems = (providerPriceList: ProviderPriceListModel) => {
  const urls = generateUrls(providerPriceList)
  const {
    editProviderPriceListUrl,
    editProviderPriceListItemsEditorUrl,
    editProviderPriceListItemsMatrixUrl,
    editProviderPriceListRelationsUrl,
  } = urls

  return [
    {
      icon: faIdCard,
      href: editProviderPriceListUrl,
      key: 'details',
      title: providerPriceList?.title || 'Price List Details',
    },
    {
      icon: faList,
      href: editProviderPriceListItemsEditorUrl,
      key: 'editor',
      title: 'Price List Items',
    },
    {
      icon: faBorderAll,
      href: editProviderPriceListItemsMatrixUrl,
      key: 'matrix',
      title: 'Pricing Matrix',
    },
    {
      icon: faToggleOn,
      href: editProviderPriceListRelationsUrl,
      key: 'relations',
      title: 'Relations',
    },
  ]
}

export default generateTabBarItems
